import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
//Styles
import './Header.css';
//Images, Icons
import  logo  from '../../images/logo.png';
import { faBars, faUserCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Header = ({color, barColor, bg}) => {
    const [navOpen, setNavOpen] = useState("none");
    const [loginOpen, setLoginOpen] = useState("none");


    const toggleLogin = () => { 
        console.log("modal toggle working")
        if (loginOpen === "none") {
            setLoginOpen("block");
        } else {
            setLoginOpen("none");
        }
    }

    const toggleNav = () => { 
        console.log("nav working");
        if (navOpen === "none") {
            setNavOpen("block");
        } else {
            setNavOpen("none");
        }
    }

    const handleLogin = () => { 
        console.log("login working");
    }

    return (
    <>  
        <div className="header__background" style={{display:bg}}></div>
        <nav className="header__wrapper">
            <div className="header__content" >
                <div className="header__logo" style={{color:color}}><a href="/"><img src={logo} alt="Logo"/><h2 className="brandName" style={{textDecoration: "none", color:color}} >trans!a</h2></a></div>
                <div className="header__navlist" style={{color:color}}>
                    <div className="navbar">
                        <ul>
                            <li className="navItem"><a href="/" style={{color:color}}>Home</a><div className="underline" style={{backgroundColor:barColor}}></div></li>
                            <li className="navItem"><a href="/services" style={{color:color}}>Services</a><div className="underline" style={{backgroundColor:barColor}}></div></li>
                            <li className="navItem"><a href="/team" style={{color:color}}>Team</a><div className="underline" style={{backgroundColor:barColor}}></div></li>
                            <li className="navItem"><a href="/about" style={{color:color}}>About Us</a><div className="underline" style={{backgroundColor:barColor}}></div></li>
                            <li className="navItem"><a href="/contact" style={{color:color}}>Contact</a><div className="underline" style={{backgroundColor:barColor}}></div></li>
                        </ul>
                    </div>
                    <button className="quoteBtn"><Link to='/quote'>quote</Link></button>
                    <FontAwesomeIcon icon={faUserCircle} className="login" onClick={toggleLogin} />
                    <FontAwesomeIcon icon={faBars} className="toggler" onClick={toggleNav}/>
                </div>
            </div>
        </nav>
        
        {/* ============= HIDDEN NAVBAR ============== */}
        <div className="header__hidden" style={{display: navOpen}}>
            {/* <div className="header__hidden__content"> */}
                <ul>
                    <li className="navItem"><a href="/">Home</a></li>
                    <li className="navItem"><a href="/services">Services</a></li>
                    <li className="navItem"><a href="/team">Team</a></li>
                    <li className="navItem"><a href="/about">About Us</a></li>
                    <li className="navItem"><a href="/contact">Contact</a></li>
                </ul>
            {/* </div> */}
        </div>

         {/* =========== LOGIN FORM ============  */}
        <div className="login__wrapper" style={{display:loginOpen}}>
            <div className="login__box">
            <div className="login__content">
                    <h2 className="login__title">
                        Welcome Back!
                        <FontAwesomeIcon icon={faTimes} onClick={toggleLogin} className="login__close" />
                    </h2>
                    <div className="login__bar"></div>
                    <Form onSubmit={handleLogin} className="login__formBody">
                        <FormGroup className="formInput">
                            <Label htmlFor="username" className="label">Username</Label>
                            <Input type="text" id="username" name="username" /* innerRef={input => username = input} */ />
                        </FormGroup>
                        <FormGroup className="formInput">
                            <Label htmlFor="password" className="label">Password</Label>
                            <Input type="password" id="password" name="password" /*innerRef={input => password = input} */ />
                        </FormGroup>
                        <FormGroup check className="formInput">
                            <Label check className="formCheck">
                                <Input type="checkbox" name="remember" className="checkbox"/* innerRef={input => remember = input} */ />
                                <p className="label">remember me</p>
                            </Label>
                        </FormGroup>
                        <Button type="submit" value="submit" color="primary">LOGIN</Button>
                    </Form>
                </div>
            </div>
        </div>
    </>
    );

};

export default Header;